import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * Metadata component - DISABLED
 *
 * This component has been disabled to prevent duplicate meta tags.
 * All meta tags are now handled by the edge function (transform.js).
 *
 * This component remains in place to avoid breaking changes, but it no longer sets any meta tags.
 */
export default function Metadata() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/|\/$/g, '');

  // Log for debugging
  useEffect(() => {
    console.log(`Metadata component loaded for ${path || 'home'} but not setting meta tags (handled by edge function)`);
  }, [path]);

  // Return empty Helmet to avoid setting any meta tags
  return <Helmet />;
}
